import { linkDeWhatsApp, saudacaoDeWhatsApp } from '@/content/contato';
import { useContato } from '@/hooks/use-conteudo';
import { useRevelarAoRolar } from '@/hooks/use-revelar-ao-rolar';
import { OrcamentoForm } from '@/modules/home/components/orcamento-form';
import { VANTAGENS } from '@/modules/home/orcamento-content';

/**
 * Seção de orçamento.
 *
 * Portada de `legacy/static-site/index.html`, seção `#orcamento`. É o destino
 * dos links do menu e de cada linha dos ambientes, que até agora não levavam a
 * lugar nenhum.
 *
 * A seção só monta a moldura e o texto ao lado; a lógica dos três passos está
 * em `orcamento-form.tsx`.
 */
export function OrcamentoSection() {
  const { ref, visivel } = useRevelarAoRolar<HTMLElement>();
  const contato = useContato();

  const revelacao = `transition-[opacity,transform] duration-[900ms] ease-plane motion-reduce:transition-none ${
    visivel ? 'translate-y-0 opacity-100' : 'translate-y-[26px] opacity-0'
  }`;

  return (
    <section
      ref={ref}
      id="orcamento"
      className="bg-brand-950 py-[clamp(70px,10vw,140px)] text-bone"
      aria-labelledby="orcamento-titulo"
    >
      <div className="mx-auto grid w-full max-w-[1360px] grid-cols-1 items-start gap-[clamp(36px,6vw,96px)] px-6 min-[980px]:grid-cols-[1fr_1.15fr]">
        <div className={revelacao}>
          <p className="flex items-center gap-2.5 text-[0.72rem] font-medium tracking-[0.22em] text-brass-light uppercase">
            <span
              aria-hidden="true"
              className="inline-block h-px w-[34px] bg-brass-light opacity-75"
            />
            Orçamento
          </p>

          <h2
            id="orcamento-titulo"
            className="mt-[1.4rem] mb-[1.2rem] font-display text-[clamp(2.1rem,5.4vw,4.4rem)] leading-[0.99] tracking-[-0.025em] text-bone"
          >
            Conta pra gente
            <br />o que você <em className="font-light text-brass-light italic">precisa</em>.
          </h2>

          <p className="mb-8 max-w-[38ch] text-bone/70">
            São três passos rápidos. Respondemos em até um dia útil com uma faixa de valor e uma
            sugestão de data para a medição.
          </p>

          <ul className="mb-[2.2rem] grid list-none gap-3 p-0">
            {VANTAGENS.map((vantagem) => (
              <li key={vantagem} className="flex items-center gap-3 text-[0.88rem] text-bone/85">
                <span
                  aria-hidden="true"
                  className="h-3.5 w-3.5 flex-none rounded-full border border-brass [background:radial-gradient(circle,var(--color-brass)_0_3px,transparent_3px)]"
                />
                {vantagem}
              </li>
            ))}
          </ul>

          <p className="m-0 text-[0.86rem] text-bone/60">
            Prefere no WhatsApp?{' '}
            <a
              href={linkDeWhatsApp(contato, saudacaoDeWhatsApp(contato))}
              target="_blank"
              rel="noopener noreferrer"
              className="border-b border-current text-brass-light"
            >
              {contato.whatsappExibicao}
            </a>
          </p>
        </div>

        <div className={revelacao}>
          <OrcamentoForm />
        </div>
      </div>
    </section>
  );
}
